import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MarkdownModule } from 'ngx-markdown';
import { DatePipe } from "@angular/common";
import { RouterModule } from '@angular/router';
import { NewsDetailsComponent } from './components/news-details/news-details.component';
import { NewsDetailsButtonsComponent } from './components/news-details-buttons/news-details-buttons.component';
import { NewsListComponent } from './components/news-list/news-list.component';

@NgModule({
    imports: [
        SharedModule,
        MarkdownModule.forRoot(),
        RouterModule
    ],
    declarations: [
        NewsDetailsComponent,
        NewsDetailsButtonsComponent,
        NewsListComponent
    ],
    exports: [NewsListComponent],
    providers: [DatePipe]
})
export class NewsModule { }
